import React, { Component } from "react";
import Footer from "./shared/Footer";
import LocalizedLink from "../containers/LocalizedLink";

import ImageBanqueMondiale_1 from "../images/realisations/projet_banque-mondiale/01-Banque-Mondiale.jpg";
import ImageBanqueMondiale_2 from "../images/realisations/projet_banque-mondiale/02-Banque-Mondiale.jpg";
import ImageBanqueMondiale_3 from "../images/realisations/projet_banque-mondiale/03-Banque-Mondiale.jpg";
import ImageBanqueMondiale_4 from "../images/realisations/projet_banque-mondiale/04-Banque-Mondiale.jpg";
import ImageBanqueMondiale_5 from "../images/realisations/projet_banque-mondiale/05-Banque-Mondiale.jpg";
import { patternsByIds } from "../constants/patterns";
import { surfacesByIds } from "../constants/surfaces";


class RealisationBanqueMondiale extends Component {
  render() {
    return (
      <React.Fragment>
        <section
          className="grid grid--2 grid--fixed"
          style={{ marginTop: "55px" }}
        >
          <LocalizedLink className="grid__item" to="/realisations">
            <div className="grid__item-title">
              <i className="f7 i-arrow-left-light" /> {this.props.t("common:realisationsBackbutton")}
            </div>
          </LocalizedLink>
          <div className="grid__item">
            <div className="grid__item-title-nohover font-bold">
              {this.props.t("realisations:internationalInstitution")} - Paris
            </div>
          </div>
        </section>

        <section className="projects">
          <div
            className="projects__item projects__item--100"
            style={{ backgroundImage: `url(${ImageBanqueMondiale_1})` }}
          >
            <div className="projects__item-label">
              {this.props.t("common:labelArchitect")} : Agence Francis Krempp
            </div>
          </div>

          <div
            className="projects__item projects__item--50"
            style={{ backgroundImage: `url(${ImageBanqueMondiale_2})` }}
          >
            <div className="projects__item-label">
              {this.props.t("common:labelArchitect")} : Agence Francis Krempp
            </div>
          </div>
          <div
            className="projects__item projects__item--50 bl"
            style={{ backgroundImage: `url(${ImageBanqueMondiale_3})` }}
          >
            <div className="projects__item-label">
              {this.props.t("common:labelArchitect")} : Agence Francis Krempp
            </div>
          </div>

          <div
            className="projects__item projects__item--50"
            style={{ backgroundImage: `url(${ImageBanqueMondiale_4})` }}
          >
            <div className="projects__item-label">
              {this.props.t("common:labelSurface")} : Oberflex - {surfacesByIds[99]["title_"+this.props.lng]} {/*Chêne teinté wengé not on line*/}
            </div>
          </div>
          <div
            className="projects__item projects__item--50 bl"
            style={{ backgroundImage: `url(${ImageBanqueMondiale_5})` }}
          >
            <div className="projects__item-label">
            {this.props.t("common:labelPattern")} : {this.props.t("common:labelCollections55")} - {patternsByIds[20]["title_"+this.props.lng]}{" "}{/* Collections 5.5 - Ligne de vie*/}
            </div>
          </div>
        </section>


          <section className="w-100 pv7">
            <div className="w-100 tc">
            <LocalizedLink className="button button--large" to="/realisations/ministere-des-affaires-etrangeres">
              <i className="button__icon i-arrow-left-light" />
              &nbsp;{this.props.t('common:labelPreviousProject')}
            </LocalizedLink>

            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;

            <LocalizedLink className="button button--large" to="/create">
            {this.props.t('common:labelCreateYourModel')}&nbsp;
              <i className="button__icon i-arrow-right-light" />
            </LocalizedLink>


            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;

            <LocalizedLink className="button button--large" to="/realisations/eurojust-la-haye">
              {this.props.t('common:labelNextProject')}&nbsp;
              <i className="button__icon i-arrow-right-light" />
            </LocalizedLink>
            </div>
          </section>

          <Footer t={this.props.t} />
      </React.Fragment>
    );
  }
}

export default RealisationBanqueMondiale;



// WEBPACK FOOTER //
// ./src/components/RealisationInstitutionInternationale.js